import React, { useEffect } from 'react';
import { parseSearch } from '../../../../../../../../../utils/utils';
import './style.scss';

interface NemIdParams {
  parameters: object;
}

interface Props {
  id: string;
  extra: {
    widgetUrl: string;
    allowFullScreen?: boolean;
    allow?: string;
    nemId?: NemIdParams;
    transactionLink?: { app: string };
    showSpinner?: boolean;
  };
  style?: object;
  onSubmit: (id: string) => void;
  onChange: (
    value: {
      id: string;
      value: string | object;
      error: boolean;
    },
    callback: () => void
  ) => void;
  onIframeLoad: () => void;
}

const Widget: React.FC<Props> = ({
  id,
  extra,
  style,
  onChange,
  onSubmit,
  onIframeLoad,
}) => {
  const { widgetUrl, allowFullScreen = false, nemId, allow } = extra;
  const sendValue = (value: string | object) => {
    onChange(
      {
        id,
        value,
        error: false,
      },
      () => {
        onSubmit(id);
      }
    );
  };
  const nemIdStrategy = (event: MessageEvent, parameters: object) => {
    let message;
    try {
      message = JSON.parse(event.data);
    } catch (e) {
      return;
    }
    const { command, content } = message;
    if (command === 'SendParameters') {
      const postMessage = {
        command: 'parameters',
        content: JSON.stringify(parameters),
      };
      const iframe = document.getElementById('iframe') as HTMLIFrameElement;
      if (iframe) {
        const win = iframe.contentWindow;
        if (win) win.postMessage(JSON.stringify(postMessage), widgetUrl);
      }
    } else if (command === 'changeResponseAndSubmit') {
      sendValue(content);
    }
  };
  const iframeHostName = widgetUrl ? new URL(widgetUrl).hostname : null;
  const onMessage = (event: MessageEvent) => {
    if (iframeHostName && event.origin.includes(iframeHostName)) {
      if (nemId) {
        nemIdStrategy(event, nemId.parameters);
      } else {
        sendValue(event.data);
      }
    } else if (event.origin.includes(document.location.host)) {
      // data received from redirect url /api/1/iframe
      if (
        typeof event.data === 'object' &&
        event.data.source === '@@redirectUrl'
      ) {
        sendValue(parseSearch(event.data.payload));
      }
    }
  };

  useEffect(() => {
    window.addEventListener('message', onMessage);
    return () => window.removeEventListener('message', onMessage);
  }, []);

  return (
    <iframe
      id="iframe"
      title={id}
      style={style}
      styleName="iframe"
      allow={allow}
      allowFullScreen={allowFullScreen}
      src={widgetUrl}
      frameBorder="0"
      onLoad={onIframeLoad}
    />
  );
};
export default Widget;
